var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoPlayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.24995 17.8675C8.1203 17.8675 7.99066 17.8338 7.87498 17.7672C7.6428 17.6332 7.5 17.3856 7.5 17.1175V6.7501C7.5 6.48202 7.6428 6.23521 7.87426 6.10119C8.10643 5.96717 8.39208 5.96496 8.62426 6.10047L17.6243 11.2816C17.8565 11.4149 18 11.6632 18 11.9313C18 12.1994 17.8572 12.4469 17.6243 12.581L8.62426 17.7672C8.50848 17.8339 8.37883 17.8675 8.24995 17.8675ZM8.99995 8.04721V15.8197L15.747 11.9312C15.747 11.9312 8.99995 8.04721 8.99995 8.04721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.38331 24 0 18.6167 0 12C0 5.38326 5.38331 0 12 0C18.6167 0 24 5.38331 24 12C24 18.6167 18.6167 24 12 24ZM12 1.5C6.21025 1.5 1.5 6.2102 1.5 12C1.5 17.7898 6.21021 22.5 12 22.5C17.7898 22.5 22.5 17.7898 22.5 12C22.5 6.21025 17.7898 1.5 12 1.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayIcon);
export default __webpack_public_path__ + "static/media/VideoPlayIcon.c48e8f52374caed2766bd17702715877.svg";
export { ForwardRef as ReactComponent };